module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "user-logo-container"
  }, [(_vm.imageLink) ? _c('img', {
    attrs: {
      "src": "",
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "welcome-text"
  }, [_vm._v("Hello , ")]), _vm._v(" "), _c('p', {
    staticClass: "welcome-text"
  }, [_vm._v(_vm._s('Pet Partner' || _vm.spriteText))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3b33d9ed!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/navbar/Userlogo.vue
// module id = 362
// module chunks = 2